import AppBar from "@mui/material/AppBar";
import { Menu as MenuIcon } from "@mui/icons-material";
import templeLogo from "../../assets/temple-logo-icon.png";
import "./Header.scss";
import { Box, Grid, Typography, Button } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { LOCALIZATION } from "../../utils/localization";
import { useMediaQuery } from "@mui/material";
function DummyHeader(props: any) {
  const appName = "Temple Dekho";
  const isMobile = useMediaQuery("(max-width:768px)");

  const tagLine = "Connecting Souls to Spirituality";

  return isMobile ? null : (
    <Box mb={75}>
      <Box className="headerMainNav">
        <AppBar component="nav">
          <nav className="headerContainer">
            <Grid
              container
              alignItems="center"
              spacing={2}
              className="row d-flex mainGrid"
            >
              <Grid item md={3} lg={3} xl={3} className="hdLeftGrid">
                <Box className="headerLeft">
                  <Box className="logo">
                    <img src={templeLogo} alt="temp logo" width={24} />
                  </Box>

                  <Box className="logoText">
                    <Typography className="logoTextTitle">{appName}</Typography>
                    <Typography className="logoTextSubTitle">
                      {tagLine}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={6} lg={6} xl={6} className="hdCenterGrid">
                <Box className="headerCenter">
                  <Box className="navLink">
                    <ul className="links">
                      <li>
                        <a>{LOCALIZATION.Home}</a>
                      </li>

                      <li>
                        <a>{LOCALIZATION.Temples}</a>
                      </li>
                      <li>
                        <a>{LOCALIZATION.Pujas}</a>
                      </li>
                      <li>
                        <a>{LOCALIZATION.Chadhava}</a>
                      </li>
                      <li>
                        <a>{LOCALIZATION.Remedy}</a>
                      </li>
                      <li>
                        <a>{LOCALIZATION.Prasad}</a>
                      </li>
                      <li>
                        <a>{LOCALIZATION.Blog}</a>
                      </li>

                      <li>
                        <a>{LOCALIZATION.Darshan}</a>
                      </li>
                    </ul>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={3} lg={3} xl={3} className="hdRightGrid">
                <Box className="headerRight">
                  <Box className="profileBlock">
                    <Button
                      className="logoutProfile"
                      variant="text"
                      startIcon={<AccountCircleRoundedIcon />}
                    >
                      {LOCALIZATION.Login}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Box className="toggleBtn">
              <MenuIcon />
            </Box>
          </nav>
        </AppBar>
      </Box>
    </Box>
  );
}

export default DummyHeader;
